import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SUPPORTED_LANG } from '../../constants/dataConstants';

type Language = (typeof SUPPORTED_LANG)[number];

interface LanguageState {
  currentLanguage: Language;
}

const savedLang = localStorage.getItem('i18nextLng');
const initialState: LanguageState = {
  currentLanguage: SUPPORTED_LANG.includes(savedLang as Language)
    ? (savedLang as Language)
    : 'en', // Persist language preference
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    toggleLanguage(state, action) {
      state.currentLanguage = action.payload;
    },
  },
});

export const { toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
